<script>
import { required } from "vuelidate/lib/validators";
export default {
    name: "ApiSectionGroupForm",
    props: {
        sectionData: {
            type: Object,
            default: () => ({
                id: 0,
                name: null,
                description: null,
                sort: null,
                allowMultiple: false,
                isRequired: false,
                inputType: null,
            }),
        },
    },
    validations: {
        formData: {
            name: { required },
        },
    },
    data() {
        return {
            submitted: false,
            formData: { ...this.sectionData },
            isEditMode: !!this.sectionData.id,
        };
    },
    methods: {
        async submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$emit("submit", this.formData);
        },
    },
}
</script>
<template>
    <form @submit.prevent="submitForm">
        <div class="mb-3 d-flex gap-1">
            <div :style="{width: '120px'}">
                <label for="sort" class="form-label">Sort</label>
                <input
                    id="sort"
                    v-model="formData.sort"
                    class="form-control"
                    autocomplete="off"
                    :disabled="formData.id == 0"
                    :placeholder="`${formData.id == 0 ? 'Auto' : ''}`"
                />
            </div>
            <div class="flex-grow-1">
                <label for="groupName" class="form-label">Group Name</label>
                <input
                    type="text"
                    id="groupName"
                    v-model="formData.name"
                    class="form-control"
                    autocomplete="off"
                />
                <div v-if="submitted && $v.formData.name.$invalid" class="invalid-feedback">
                    Group name is required.
                </div>
            </div>
        </div>
        <div class="mb-3 d-flex gap-1">
            <div class="w-50">
                <label for="sectionDescription" class="form-label">Description</label>
                <textarea
                    id="sectionDescription"
                    v-model="formData.description"
                    autocomplete="off"
                    class="form-control"
                    rows="1"
                ></textarea>
            </div>
            <div class="w-50">
                <label for="inputType" class="form-label">Input Type</label>
                <input
                    type="text"
                    id="inputType"
                    v-model="formData.inputType"
                    class="form-control"
                    autocomplete="off"
                />
            </div>
        </div>
        <div class="d-flex mb-3 gap-2">
            <div
                class="
                    form-check
                    form-checkbox-outline
                    form-check-success
                "
            >
                <input
                    type="checkbox"
                    id="customCheckcolor2"
                    checked="checked"
                    class="form-check-input"
                    v-model="formData.allowMultiple"
                /><label
                    for="customCheckcolor2"
                    class="form-check-label"
                >
                    Allow Multiple
                </label>
            </div>
            <div
                class="
                    form-check
                    form-checkbox-outline
                    form-check-success
                "
            >
                <input
                    type="checkbox"
                    id="customCheckcolor3"
                    checked="checked"
                    class="form-check-input"
                    v-model="formData.isRequired"
                /><label
                    for="customCheckcolor3"
                    class="form-check-label"
                >
                    Required
                </label>
            </div>
        </div>
        <div class="d-flex justify-content-end gap-1">
            <button type="submit" class="btn btn-primary d-flex align-items-center gap-1">
                <i class="bx bx-save"></i> {{ isEditMode ? "Update" : "Create" }}
            </button>
            <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-1" @click="$emit('cancel')">
                <i class="bx bx-x"></i> Cancel
            </button>
        </div>
    </form>
</template>